import global from "../../../common/utility/global";

export function formatCurrency(value, moneda = "PEN", decimales = 2) {
    const numero = Number(value) || 0;
    const simbolo = moneda === "USD" ? "US$" : "S/";
    return `${simbolo} ${global.decimalFormat(numero.toFixed(decimales))}`;
}

export function formatNumber(value, decimales = 1) {
    const numero = Number(value) || 0;
    return global.decimalFormat(numero.toFixed(decimales));
}

function construirKpi(soles, dolares) {
    return {
        pen: Number(soles) || 0,
        usd: Number(dolares) || 0,
    };
}

// Tramos de antiguedad con su monto y % sobre el total, por moneda. El API
// puede omitir los tramos sin deuda, asi que se conserva "orden" para que
// cada tramo mantenga su color aunque falten los anteriores.
function construirAntiguedad(filas) {
    const tramos = filas
        .map((fila, indice) => ({ ...fila, orden: Number(fila.orden) || indice + 1 }))
        .sort((a, b) => a.orden - b.orden);

    const construirMoneda = (campo) => {
        const total = tramos.reduce((acumulado, fila) => acumulado + (Number(fila[campo]) || 0), 0);
        return {
            total,
            datos: tramos.map((fila) => {
                const monto = Number(fila[campo]) || 0;
                return {
                    orden: fila.orden,
                    nombre: fila.rangoAntiguedad,
                    total: monto,
                    porcentaje: total > 0 ? (monto / total) * 100 : 0,
                };
            }),
        };
    };
    return {
        pen: construirMoneda("totalPEN"),
        usd: construirMoneda("totalUSD"),
    };
}

export function buildDashboardData(response) {
    // El servicio (cuentasCobrarService.dashboardDeuda) devuelve:
    // - cuentasCobrar / cuentasPagar: arreglo de un solo elemento con el
    //   total y la deuda vencida en soles y dolares. Ambos usan los mismos
    //   nombres de campo (cuentasPagar tambien trae "totalCuentasPorCobrar").
    // - cuentasCobrarAntes / cuentasPagarAntes: una fila por tramo de
    //   antiguedad ({ orden, rangoAntiguedad, totalPEN, totalUSD }).
    const cobrar = (response && response.cuentasCobrar && response.cuentasCobrar[0]) || {};
    const pagar = (response && response.cuentasPagar && response.cuentasPagar[0]) || {};
    const antiguedadCobrar = (response && response.cuentasCobrarAntes) || [];
    const antiguedadPagar = (response && response.cuentasPagarAntes) || [];

    return {
        kpis: {
            totalCobrar: construirKpi(cobrar.totalCuentasPorCobrar, cobrar.totalCuentasDolar),
            vencidoCobrar: construirKpi(cobrar.totalDeudaVencida, cobrar.totalDeudaDolar),
            totalPagar: construirKpi(pagar.totalCuentasPorCobrar, pagar.totalCuentasDolar),
            vencidoPagar: construirKpi(pagar.totalDeudaVencida, pagar.totalDeudaDolar),
        },
        antiguedadCobrar: construirAntiguedad(antiguedadCobrar),
        antiguedadPagar: construirAntiguedad(antiguedadPagar),
    };
}
